import { keysToCamel } from "@lib/snakeTocamel"
import { sanitizer } from "@commonUtils"

const PATHOLOGY_LAB_TEST_BOOKING_FORM = "pathology_lab_test_booking_form"
const RADIOLOGY_LAB_TEST_BOOKING_FORM = "radiology_lab_test_booking_form"
/**
 * @description Prase the Bottom Sheet (modal) and returns sheetName string and sheetData object
 * @param {string} bottomSheetKey Key to match with switch case block
 * @param {object} bottomSheet sheet raw data to be parsed
 * @return {[sheetName:string,sheetData:object]}
 */
export const parseBottomSheetData = (bottomSheetKey, bottomSheet) => {
    let sheetName = ""
    let sheetData = {}
    let selectCityData = {
        cta: {
            size: "large",
            type: "primary",
            label: "Continue",
            action: "click",
            functionMap: "setSelectedCity",
        },
        header: {
            text: "Select City",
        },
    }

    switch (bottomSheetKey) {
        case "how_to_schedule_test": {
            sheetName = "howToScheduleTest"
            sheetData.header = bottomSheet?.header
            sheetData.cta = keysToCamel(bottomSheet?.cta)
            sheetData.steps = bottomSheet?.steps
            break
        }
        case "select_city": {
            sheetName = "selectCity"
            sheetData.header = selectCityData?.header
            sheetData.cta = selectCityData?.cta
            break
        }
        case "select_patient": {
            sheetName = "selectPatient"
            sheetData.header = bottomSheet?.header
            sheetData.patientList = bottomSheet?.patient_list
            sheetData.cta = keysToCamel(bottomSheet?.cta)
            sheetData.gaDetails = bottomSheet?.ga_details || {}
            sheetData.onChangeGaDetails = bottomSheet?.on_change_ga_details || {}
            break
        }
        case "select_lab_test": {
            sheetName = "selectLabTest"
            const bottomSheetData = {
                placeholderData: {
                    image: {
                        url: bottomSheet?.placeholder_data?.image?.url,
                        alt: bottomSheet?.placeholder_data?.image?.alt,
                    },
                    heading: bottomSheet?.placeholder_data?.heading,
                    subHeading: bottomSheet?.placeholder_data?.subHeading,
                    class: bottomSheet?.placeholder_data?.class,
                },
                header: bottomSheet?.header,
                subText: bottomSheet?.sub_text?.text,
                primaryActionLabel: bottomSheet?.cta_label,
                listOfTests: bottomSheet?.data?.map((test) => {
                    return {
                        id: test?.id,
                        header: test?.header?.text,
                        priceFooter: {
                            price: test?.price?.mrp,
                            discountedPrice: test?.discounted_price,
                        },
                        subHeader: test?.sub_header?.text,
                        description: test?.description?.text,
                        primaryLabel: test?.cta?.label,
                        secondaryLabel: "",
                        tags: test?.tags,
                        url: test?.proceed_cta?.url,
                        testDetails: {
                            key: test?.test_details?.header?.text,
                            header: test?.test_details?.header?.text,
                            tags: test?.test_details?.tags?.map((tag) => ({
                                backgroundColor: tag.bg_color,
                                text: tag.text,
                                color: tag.text_color,
                            })),
                            tat: test?.test_details?.tat,
                            testHeader: test?.test_details?.test_header,
                            price: {
                                price: test?.test_details?.price,
                                discountedPrice: test?.test_details?.discounted_price,
                            },
                            footer: test?.test_details?.footer,
                            subText: test?.test_details?.sub_header?.text,
                            description: {
                                text: sanitizer(test?.test_details?.description?.text, {
                                    FORBID_ATTR: ["style"],
                                }),
                                backgroundColor: test?.test_details?.description?.bg_color,
                            },
                            descriptionCta: test?.test_details?.description_cta,
                            listOfItems: test?.test_details?.test?.map((item) => {
                                return {
                                    type: item?.type,
                                    header: item?.text,
                                    subtext: item?.subtext?.text,
                                    parameters: item?.data,
                                }
                            }),
                        },
                        cta: { ...test?.cta, gaDetails: test?.cta?.ga_details },
                        proceedCta: { gaDetails: test?.proceed_cta?.ga_details, ...test?.proceed_cta },
                        onExpandCta: { gaDetails: test?.test_info_expand_ga_details },
                        onScrollCta: { gaDetails: test?.test_info_scroll_ga_details },
                        isPathology: test?.is_pathology,
                        isRadiology: test?.is_radiology,
                        isTestFeasible: true,
                        error: { ...test?.error },
                    }
                }),
                gaDetails: bottomSheet?.ga_details || {},
            }
            sheetData = keysToCamel(bottomSheetData)
            break
        }
        case "path_test_location": {
            sheetName = "testLocation"
            sheetData = { pathology: keysToCamel(bottomSheet) }
            break
        }
        case "radio_test_location": {
            sheetName = "testLocation"
            sheetData = { radiology: keysToCamel(bottomSheet) }
            break
        }
        case "labs_preparation": {
            sheetName = "labsPreparation"
            sheetData = keysToCamel(bottomSheet?.data)
            break
        }
        case "slot_selector": {
            sheetName = "slotSelector"
            sheetData.header = bottomSheet?.data?.header
            sheetData.cta = keysToCamel(bottomSheet?.data?.cta)
            sheetData.gaDetails = bottomSheet?.data?.ga_details || {}
            sheetData.onChangeGaDetails = bottomSheet?.data?.on_change_ga_details || {}
            sheetData.slots = {}
            let slot
            bottomSheet?.data?.days_array?.forEach((day) => {
                slot = {
                    title: day?.title,
                    available: day?.available,
                    epochSlot: day?.epoch_slot,
                    isSelected: day?.is_selected,
                    dayIndex: day?.day_index,
                    date: day?.date,
                }
                slot.timeSlotData = {}
                const timeSlotData = bottomSheet?.data?.time_slot_data[slot.epochSlot]
                if (timeSlotData) {
                    if (!timeSlotData?.slot_data?.length) {
                        slot.timeSlotData.emptySlot = {
                            image: {
                                url: timeSlotData?.empty_slot_data?.image?.url,
                                alt: timeSlotData?.empty_slot_data?.image?.alt || "No Slot",
                                height: timeSlotData?.empty_slot_data?.image?.height,
                                width: timeSlotData?.empty_slot_data?.image?.width,
                            },
                            header: timeSlotData?.empty_slot_data?.heading,
                            description: timeSlotData?.empty_slot_data?.description,
                        }
                    } else {
                        slot.timeSlotData.timeSlots = timeSlotData?.slot_data?.map((item) => ({
                            slotId: item?.slot_id,
                            epochSlot: item?.epoch_slot,
                            label: item?.label,
                            subText: item?.sub_text,
                            available: item?.available,
                            isSelected: item?.is_selected,
                            slotIndex: item?.slot_index,
                        }))
                    }
                }
                if (slot.isSelected) {
                    sheetData.selectedSlotId = slot.epochSlot
                }

                sheetData.slots[slot.epochSlot] = slot
            })
            break
        }
        case "no_slot_widget": {
            sheetName = "noSlots"
            sheetData = keysToCamel(bottomSheet?.data)
            break
        }
        case "patient_details": {
            sheetName = "patientDetails"
            sheetData = parseProfileWidgetData(bottomSheet)
            break
        }
        default: {
            break
        }
    }

    return [sheetName, sheetData]
}

const toCamel = (s) => {
    return s.replace(/([-_][a-z])/gi, ($1) => {
        return $1.toUpperCase().replace("-", "").replace("_", "")
    })
}

const snakeToCamel = function (s) {
    if (typeof s === "string") return toCamel(s)
}

const parsePopupData = (popupKey, popup) => {
    const popupName = snakeToCamel(popupKey)

    let popupData = {
        image: popup?.image,
        header: popup?.header,
        description: popup?.description,
        cta: keysToCamel(popup?.cta),
    }

    return [popupName, popupData]
}

export const parseAddressById = (addressObj) => {
    let addressById = {
        name: addressObj?.data?.address_name
            ? addressObj?.data?.address_name
            : addressObj?.data?.address_type,
        id: addressObj?.data?.id,
        city: addressObj?.data?.city,
        recipientPhone: addressObj?.data?.number,
        country: addressObj?.data?.country,
        recipientName: addressObj?.data?.name,
        pincode: addressObj?.data?.pincode,
        state: addressObj?.data?.state,
        addressText: addressObj?.data?.street1,
    }

    return addressById
}

const initialErrorHandling = (field, formData) => {
    if (!field?.error?.initialError) {
        formData[field.name].isDisabled = false
        formData[field.name].error = false
    } else {
        formData[field.name].isDisabled = field.cta?.isDisabled
        formData[field.name].error = field.error
    }
}

const getFormData = (widget, formData) => {
    const currentStepForm = {
        header: widget?.header,
        description: widget?.description,
        tags: widget?.tags,
        formHeader: keysToCamel(widget?.form_header),
        form: { cta: keysToCamel(widget?.form?.cta), fields: [] },
        isBooked: widget.is_booked,
    }
    const fieldOrder = widget?.form?.fields_order
    fieldOrder?.forEach((fieldKey) => {
        const field = keysToCamel(widget?.form?.fields?.[fieldKey])
        if (field.cta) {
            field.cta.changeLabel =
                field?.cta?.bottomSheetKey === "patient_details" ? field.cta.label : "Change"
        }
        currentStepForm.form.fields.push(field)
    })
    currentStepForm.form.fields.forEach((field) => {
        // This condition is for data persisted in local storage
        if (!widget.is_booked && (formData[field.name]?.value || formData[field.name]?.error)) {
            // to show error when the user lands on the page
            initialErrorHandling(field, formData)
        } else {
            if (field?.value) {
                formData[field.name] = {
                    value: field?.value,
                    displayValue: field?.displayValue?.text,
                    isDisabled: field.cta?.isDisabled,
                    image: field?.icon,
                    id: field?.value,
                    isVisible: field.isVisible,
                    ...(field?.error?.initialError &&
                    (widget.type === PATHOLOGY_LAB_TEST_BOOKING_FORM ||
                        widget.type === RADIOLOGY_LAB_TEST_BOOKING_FORM)
                        ? { error: field.error }
                        : {}),
                    ...(field?.metadata || {}),
                }
            } else {
                formData[field.name] = {
                    value: "",
                    isDisabled: formData[field.name]
                        ? formData[field.name]?.isDisabled
                        : field.cta?.isDisabled,
                    isVisible: formData[field.name] ? formData[field.name]?.isVisible : field.isVisible,
                    ...(field?.error?.initialError &&
                    (widget.type === PATHOLOGY_LAB_TEST_BOOKING_FORM ||
                        widget.type === RADIOLOGY_LAB_TEST_BOOKING_FORM)
                        ? { error: field.error }
                        : {}),
                }
            }
        }
    })
    return currentStepForm
}

/**
 * @description Prase the Widgets data and returns data to be saved in reducer
 * @param {object} data
 */
export const parseWidgetData = (data, prevPageData = {}, prevFormData = {}) => {
    let widgetsData = {}
    const bottomSheets = prevPageData?.bottomSheets || {}
    const popups = prevPageData?.popups || {}
    const formData = prevFormData || {}
    let feasibility = {}

    const userData = data.userData
    const corporateDetails = data.corporateDetails

    const onPageLoadGA = data?.ga_details
    onPageLoadGA.label.corporateDetails = {
        ...(onPageLoadGA.label?.corporateDetails || {}),
        corporate_name: corporateDetails?._source,
        user_id: userData?.userId,
    }
    const widgetsArr = data?.widgets

    let sheetName, sheetData
    for (const bottomSheet in data?.bottom_sheets) {
        ;[sheetName, sheetData] = parseBottomSheetData(bottomSheet, data?.bottom_sheets[bottomSheet])
        if (bottomSheets[sheetName]) {
            bottomSheets[sheetName] = { ...bottomSheets[sheetName], ...sheetData }
        } else {
            bottomSheets[sheetName] = sheetData
        }
    }

    let popupName, popupData
    for (const popup in data?.popups) {
        ;[popupName, popupData] = parsePopupData(popup, data?.popups[popup])
        if (popupName) popups[popupName] = popupData
    }

    let bookingFormSection = prevPageData?.widgets?.bookingFormSection || {}
    widgetsArr?.forEach((widget) => {
        switch (widget?.type) {
            case "lab_test_booking_review": {
                let reviewDetails = {}
                reviewDetails.type = "bookingDetailsInfo"
                reviewDetails.header = widget?.header?.text || ""
                reviewDetails.description = widget?.description?.text || ""
                let rows = []
                widget?.fields_order.forEach((order) => {
                    if (widget?.booking_details_info[order] != null) {
                        rows.push(widget?.booking_details_info[order])
                    }
                })
                reviewDetails.rows = rows
                if (!bookingFormSection[data.step]) bookingFormSection[data.step] = {}
                bookingFormSection[data.step]["reviewDetails"] = reviewDetails
                widgetsData = { ...widgetsData, bookingFormSection }
                return
            }

            case "summary_note": {
                let noteInfo = {}
                let instructions = []
                widget?.note_info?.path_details ? instructions.push(widget?.note_info.path_details) : ""
                widget?.note_info?.radio_details ? instructions.push(widget?.note_info.radio_details) : ""
                noteInfo.type = "noteInfo"
                noteInfo.header = widget.note_info?.header || ""
                noteInfo.showSweeper = widget.note_info?.showSweeper || ""
                noteInfo.active = widget.note_info?.active || ""
                noteInfo.rows = instructions || []
                bookingFormSection[data.step]["noteInfo"] = noteInfo
                widgetsData = { ...widgetsData, bookingFormSection }

                return
            }

            case "loader_status": {
                let confirmBookingStatus = widget?.loader_status
                bookingFormSection[data.step]["confirmBookingStatus"] = confirmBookingStatus
                widgetsData = { ...widgetsData, bookingFormSection }

                return
            }

            case "confirm_booking_cta": {
                let confirmBookingCta = keysToCamel(widget?.confirm_booking_info?.cta) || {}
                bookingFormSection[data.step]["confirmBookingCta"] = confirmBookingCta
                widgetsData = { ...widgetsData, bookingFormSection }
                return
            }

            case "cover_images_carousel": {
                let carouselSection = {}
                carouselSection.images = widget?.images || []
                carouselSection.benefitsInfo = widget?.benefits_info || {}
                widgetsData = { ...widgetsData, carouselSection }
                return
            }
            case "cover_image": {
                const coverImage = prevPageData?.widgets?.coverImage || {}
                coverImage[data.step] = widget?.image
                widgetsData = { ...widgetsData, coverImage }
                return
            }
            case "stepper": {
                widgetsData = { ...widgetsData, stepper: keysToCamel(widget.data) }
                return
            }
            case "lab_test_booking_form": {
                const currentStepForm = getFormData(widget, formData)
                bookingFormSection[data.step] = currentStepForm
                const feasibilityData = bookingFormSection[data.step]?.form?.cta?.feasibility
                if (feasibilityData) {
                    feasibility = { ...feasibility, ...feasibilityData }
                    delete bookingFormSection[data.step]?.form?.cta?.feasibility
                }
                widgetsData = { ...widgetsData, bookingFormSection }
                return
            }
            case PATHOLOGY_LAB_TEST_BOOKING_FORM:
            case RADIOLOGY_LAB_TEST_BOOKING_FORM: {
                if (!formData[widget?.form?.key]) {
                    formData[widget?.form?.key] = {}
                }
                const subForm = formData[widget?.form?.key]
                const currentStepForm = getFormData(widget, subForm)
                if (!formData[widget?.form?.key]) formData[widget?.form?.key] = subForm
                currentStepForm.key = widget?.form?.key
                bookingFormSection[data.step] = {
                    ...(bookingFormSection[data.step] || {}),
                    [widget?.form?.key]: currentStepForm,
                }
                feasibility = { ...feasibility }
                widgetsData = { ...widgetsData, bookingFormSection }
                return
            }

            default:
                break
        }
    })

    return {
        widgets: widgetsData,
        bottomSheets,
        popups,
        onPageLoadGA,
        formData,
        currentStep: data.step,
        metaData: data?.meta_data,
        patientId: data?.patient_id,
        patientName: data?.patient_details?.name,
        feasibility,
    }
}

/**
 * @description Prase the slot selection bottom sheets and return bottom sheet data
 * @param {object} data
 * @param {object} bottomSheets
 */
export const parseSlotSelectionData = (data) => {
    const bottomSheets = {}
    const popups = {}
    let sheetName, sheetData
    for (const bottomSheet in data?.bottom_sheets) {
        ;[sheetName, sheetData] = parseBottomSheetData(bottomSheet, data?.bottom_sheets[bottomSheet])
        if (bottomSheets[sheetName]) {
            bottomSheets[sheetName] = { ...bottomSheets[sheetName], ...sheetData }
        } else {
            bottomSheets[sheetName] = sheetData
        }
    }
    let popupName, popupData
    for (const popup in data?.popups) {
        ;[popupName, popupData] = parsePopupData(popup, data?.popups[popup])
        if (popupName) popups[popupName] = popupData
    }
    return { bottomSheets, popups }
}

export const parseCenterDetails = (data) => {
    const staticData = {
        cta: {
            size: "large",
            type: "primary",
            label: "Continue",
            action: "click",
            gaDetails: {
                label: "Continue",
                action: "",
            },
            functionMap: "setCampDetails",
        },
    }

    const parsedData = []
    data?.widgets?.forEach((widget) => {
        switch (widget?.type) {
            case "list_camp":
            case "list_home":
            case "list_centre": {
                const widgetData = widget?.data
                staticData.type = widget?.type
                staticData.header = { text: data?.meta_data?.page_title }
                staticData.labs = widgetData?.locations.map((lab) => ({
                    id: lab?.id,
                    header: { text: lab?.header },
                    description: {
                        text: lab?.sub_header,
                        image: {
                            alt: "Location",
                            url: "https://onemg.gumlet.io/staging/066e2771-9fa2-4f5b-ab9a-fc2fcafc414d.svg",
                            width: "18px",
                            height: "18px",
                        },
                    },
                    address: lab?.address,
                    gaDetails: lab?.ga_details || {},
                }))
                staticData.gaDetails = widgetData?.ga_details || {}
                parsedData.push(staticData)
                break
            }
            case "no_results": {
                const widgetData = widget?.data
                parsedData.push({
                    type: widget?.type,
                    header: widgetData?.header,
                    subHeader: widgetData?.subHeader,
                    imageUrl: widgetData?.image_url,
                    gaDetails: widgetData?.ga_details || {},
                })
            }
        }
    })
    return parsedData
}

export const parsePatientFormFields = (overrideData, templateData, type) => {
    return {
        header: overrideData?.header || templateData?.header,
        fields: overrideData?.fields?.map((field) => {
            const templateValue = templateData.fields[field.key]
            return {
                ...templateValue,
                ...field,
                displayValue: field.value,
                isEditable: field.is_editable,
                label: field.is_editable ? templateValue.label + "*" : templateValue.label,
                alertMessage: templateValue.alert_message && {
                    description: templateValue.alert_message.description,
                    image: templateValue.alert_message.image,
                    backgroundColor: templateValue.alert_message.background_color,
                    textColor: templateValue.alert_message.text_color,
                    gaDetails: templateValue.alert_message.ga_details,
                },
            }
        }),
        cta: {
            ...templateData.cta,
            ...overrideData.cta,
        },
        isReadOnly: overrideData.fields?.every((field) => !field?.is_editable),
        gaDetails: overrideData.ga_details,
        type,
    }
}

export const parseProfileWidgetData = (data) => {
    const widgetData = data
    const addCta = data.dynamicCtaField
    const parsedData = {
        ...widgetData,
        heading: widgetData?.header?.text,
        description: widgetData?.sub_header?.text,
        patientsList: null,
        ctaData: keysToCamel(widgetData.cta),
        addPatientData: addCta && {
            ...addCta,
            formFields: parsePatientFormFields(addCta.bottom_sheet_data, widgetData, "add"),
            gaDetails: addCta.ga_details,
        },
        emptyPatientData: {
            image: {
                alt: widgetData?.empty_patient_data?.image?.alt,
                url: widgetData?.empty_patient_data?.image?.url,
            },
        },
        gaDetails: widgetData?.ga_details,
        consentDetails: widgetData.confirm_details && {
            isSelected: widgetData.confirm_details.is_selected,
            description: widgetData.confirm_details.text,
            gaDetails: widgetData.confirm_details.ga_details,
        },
    }
    return parsedData
}

export const findTimeSlotById = (data, targetSlotId) => {
    let foundSlot = null
    for (const day of Object.values(data)) {
        if (day.available && day.timeSlotData.timeSlots) {
            foundSlot = day.timeSlotData.timeSlots.find((slot) => {
                return slot.slotId === targetSlotId
            })
            if (foundSlot) {
                return foundSlot
            }
        }
    }

    return foundSlot
}
